<div class="flex flex-col flex-auto min-w-0">

  <!-- Header -->
  <app-generic-breadcrumbs terminal="Companies" fallbackIcon="heroicons_solid:briefcase"></app-generic-breadcrumbs>

  <!-- Main -->
  <div class="flex-auto p-6 sm:p-6">
    <div class="flex items-center mt-4 sm:mt-0 md:mt-4">
      <!-- Search -->
      <div class="flex-auto">
        <mat-form-field class="fuse-mat-dense fuse-mat-no-subscript fuse-mat-rounded w-full min-w-50">
          <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:search'"></mat-icon>
          <input matInput [(ngModel)]="searchText" [autocomplete]="'off'"
            (ngModelChange)="seachTextDidChange(searchText)" [placeholder]="'Filter companies'">
        </mat-form-field>
      </div>
      <!-- Add company button -->
      <a routerLink="/add-company">
        <button class="ml-4" mat-flat-button [color]="'primary'">
        <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
        <span class="ml-2 mr-1">Add</span>
      </button>
      </a>
    </div>
     

    <!--list-->
    <!--loading-->
    <div *ngIf="viewState == viewStates.loading">
      <mat-spinner class="ml-auto mr-auto mt-5"></mat-spinner>
    </div>

    <!-- no content -->
    <div *ngIf="viewState == viewStates.content && filteredCompanies.length === 0" class="mt-8">
      <app-generic-no-content 
      title="No Companies Found"
      subtitle="No companies were found please refresh or update your search criteria."
      imageUrl="https://img.icons8.com/color/256/000000/briefcase.png"
      class="ml-auto mr-auto mt-5"></app-generic-no-content>
    </div>

    <!-- content -->
    <div [hidden]="viewState != viewStates.content || filteredCompanies.length === 0" class="w-full mt-8">
      <fuse-card class="w-full p-4">
        <div class="w-full overflow-x-auto mx-6">
          <table
              class="w-full bg-transparent"
              mat-table
              matSort
              [dataSource]="companiesDataSource"
              [trackBy]="trackByFn"
              #companiesTable>
  
              <!-- Name -->
              <ng-container matColumnDef="name">
                  <th
                      mat-header-cell
                      mat-sort-header
                      *matHeaderCellDef>
                      Name
                  </th>
                  <td
                      mat-cell
                      *matCellDef="let company">
                      <a routerLink="/companies/{{company.id}}" class="pr-6 font-medium text-sm text-secondary whitespace-nowrap">
                        <img class="inline mr-3 rounded" style="width: 24px; vertical-align: middle;" *ngIf="company.imageUrl != null" [src]="company.imageUrl" />
                        <mat-icon *ngIf="company.imageUrl == null" class="mr-3 text-primary" style="vertical-align: bottom;"
                    [svgIcon]="'heroicons_solid:briefcase'"></mat-icon>
                          <b class="text-slate-600"
                          [matTooltip]="company.notes"
                          >{{company.name}}</b>
                      </a>
                  </td>
              </ng-container>
  
              <!-- Agency -->
              <ng-container matColumnDef="agency.name">
                  <th
                      mat-header-cell
                      mat-sort-header
                      *matHeaderCellDef>
                      Agency
                  </th>
                  <td
                      mat-cell
                      *matCellDef="let company">
                      <a routerLink="/agencies/{{company.agency?.id}}" class="pr-6 font-medium text-sm text-secondary whitespace-nowrap">
                        {{company.agency?.name}}
                    </a>
                  </td>
              </ng-container>

              <!-- Ops Rep -->
              <ng-container matColumnDef="opsRep">
                <th
                    mat-header-cell
                    mat-sort-header
                    *matHeaderCellDef>
                    Ops Rep
                </th>
                <td
                    mat-cell
                    *matCellDef="let company">
                    <a routerLink="/staff/{{company.opsRep?.id}}" class="pr-6 font-medium text-sm text-secondary whitespace-nowrap">
                        {{company.opsRep?.name}}
                    </a>
                </td>
            </ng-container>

            <!-- Sales Rep -->
            <ng-container matColumnDef="salesRep">
                <th
                    mat-header-cell
                    mat-sort-header
                    *matHeaderCellDef>
                    Sales Rep
                </th>
                <td
                    mat-cell
                    *matCellDef="let company">
                    <a routerLink="/staff/{{company.salesRep?.id}}" class="pr-6 font-medium text-sm text-secondary whitespace-nowrap">
                        {{company.salesRep?.name}}
                    </a>
                </td>
            </ng-container>

              <!-- Footer -->
              <!-- <ng-container matColumnDef="recentOrdersTableFooter">
                  <td
                      class="py-6 px-0 border-0"
                      mat-footer-cell
                      *matFooterCellDef
                      colspan="6">
                      <button mat-stroked-button>See all companys</button>
                  </td>
              </ng-container> -->
  
              <tr
                  mat-header-row
                  *matHeaderRowDef="companiesTableColumns"></tr>
              <tr
                  class="order-row h-16"
                  mat-row
                  *matRowDef="let row; columns: companiesTableColumns;"></tr>
              <!-- <tr
                  class="h-16 border-0"
                  mat-footer-row
                  *matFooterRowDef="['recentOrdersTableFooter']"></tr> -->
          </table>
      </div>
      </fuse-card>
    </div>
  </div>

</div>